import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PagesRoutingModule} from './pages-routing.module';
import {ListPageComponent} from './list-page/list-page.component';
import {CreatePageComponent} from './create-page/create-page.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {EditpagesComponent} from './editpages/editpages.component';
import {OurchannelComponent} from './ourchannel/ourchannel.component';
import {ChannelmessageComponent} from './channelmessage/channelmessage.component';
import {ViewpagesComponent} from './viewpages/viewpages.component';

@NgModule({
    declarations: [ListPageComponent, CreatePageComponent, EditpagesComponent, OurchannelComponent, ChannelmessageComponent, ViewpagesComponent],
    imports: [
        CommonModule,
        PagesRoutingModule,
        NgbModule,
        ReactiveFormsModule,
        SharedModule,
        DragDropModule,
        FormsModule,
    ]
})
export class PagesModule {
}
